import {StyleSheet} from 'react-native';

import {TAB_BAR_HEIGH} from '/component/layout/TabLayout/TabLayout.style';
import {indent} from '/constant/layout.constant';
import {onyxLight, white} from '/theme/color/on.color';
import {darkRed, salmonPink} from '/theme/color/secondary.color';

const baseStyles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  header: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 16,
    marginTop: indent * 0.5,
    paddingLeft: indent,
  },
  label: {
    paddingLeft: indent,
    marginBottom: indent * 0.1,
  },
  inputBox: {
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: onyxLight,
    backgroundColor: white,
    width: '90%',
    marginLeft: indent * 1,
    borderRadius: indent * 0.4,
    marginBottom: indent * 1,
    height: 50,
  },
  inputText: {
    paddingLeft: indent * 0.5,
  },
  inputError: {
    borderColor: salmonPink,
    marginBottom: indent * 0.1,
    height: 50,
  },
  errorLabel: {
    paddingLeft: indent * 1,
    marginBottom: 12,
    color: darkRed,
  },
});

export const styles = {
  ...baseStyles,
  base: {
    ...baseStyles.base,
    overflow: 'hidden',
    overflowY: 'hidden',
    overflowX: 'hidden',
  },
  webScrollContainer: {
    flex: 1,
    minHeight: 0,
    height: '100%',
    maxHeight: '100dvh',
    overflowY: 'scroll',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    paddingBottom: TAB_BAR_HEIGH,
    overscrollBehavior: 'contain',
  },
} as any;
